import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { ChangeRequestTab, ChangeRequestTabRoutes } from '../enum'

export const CHANGE_REQUEST_TAB_PARAM = 'cr_tab'

@Injectable({ providedIn: 'root' })
export class ChangeRequestNavigationService {
  currentTab: string

  constructor(private router: Router) {}

  selectTab(tab: string, navigate = true) {
    this.currentTab = tab

    if (navigate) {
      const tabParam = ChangeRequestTabRoutes[tab as ChangeRequestTab]
      this.router.navigate([], { queryParams: tabParam ? { [CHANGE_REQUEST_TAB_PARAM]: tabParam } : null })
    }
  }
}
